<template>
    <div class="admin-agent">
        <div class="paca-group">
            <div class="paca-group-list" :class="`list-${groupIndex}`" v-for="(groupItem, groupIndex) in agentList" :key="groupIndex" :name="groupItem.id">
                <div class="paca-group-list__header" @click="itemCollapse(groupIndex)">
                    <i class="paca-group-list__header-icon"></i>
                    <span class="paca-group-list__header-text">
                        <span class="paca-group-list__header-text-nickname">{{groupItem.site_owner_nickname}}</span>
                        <span class="paca-group-list__header-text-email">({{groupItem.site_owner_email}})</span>
                        <span class="paca-group-list__header-text-length">{{groupItem.result.length}}</span>
                    </span>
                </div>
                <div class="paca-group-list__content">
                    <div class="admin-agent-list-email">
                        <div class="admin-agent-list-email-label">Email</div>
                        <div class="admin-agent-list-email-value">{{groupItem.site_owner_email}}</div>
                    </div>
                    <div class="paca-table">
                        <div class="paca-table__header">
                            <div class="paca-table__header-item item-column column-lock"></div>
                            <div class="paca-table__header-item item-column column-nickname">代理人({{groupItem.result.length}})</div>
                            <div class="paca-table__header-item item-column column-accounting">帳務</div>
                            <div class="paca-table__header-item item-column column-gate">場務</div>
                            <div class="paca-table__header-item item-column column-cars">車籍</div>
                            <div class="paca-table__header-item item-column column-import">匯入</div>
                            <div class="paca-table__header-item item-column column-config">設定</div>
                            <div class="paca-table__header-item item-column column-extra"></div>
                        </div>
                        <div class="paca-table__body" v-if="groupItem.result.length > 0">
                            <div class="paca-table__body-col" v-for="(listItem, listIndex) in groupItem.result" :key="listIndex">
                                <div class="paca-table__body-col-list">
                                    <div class="paca-table__body-col-list-item item-column column-email">{{listItem.email}}</div>
                                    <div class="paca-table__body-col-list-item item-column column-lock">
                                        <button class="column-lock-icon" :class="listItem.is_locked==0?'unlock el-icon-unlock':'lock paca-icon-lock'" @click="lockItem(listItem)"></button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-user overflow-text">{{listItem.nickname}}</div>
                                    <div class="paca-table__body-col-list-item item-column column-gate">
                                        <button class="checkbox-button" :class="{'is-check': listItem.cbox_permission.priv_accounting.enable == 1}" @click="changeAgentItemAuthority(groupIndex, listIndex, 'priv_accounting')" :disabled="listItem.is_locked==1"></button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-gate">
                                        <button class="checkbox-button" :class="{'is-check': listItem.cbox_permission.priv_gate.enable == 1}" @click="changeAgentItemAuthority(groupIndex, listIndex, 'priv_gate')" :disabled="listItem.is_locked == 1"></button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-cars">
                                        <button class="checkbox-button" :class="{'is-check': listItem.cbox_permission.priv_car_edit.enable == 1}" @click="changeAgentItemAuthority(groupIndex, listIndex, 'priv_car_edit')" :disabled="listItem.is_locked==1"></button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-import">
                                        <button class="checkbox-button" :class="{'is-check': listItem.cbox_permission.priv_car_import.enable == 1}" @click="changeAgentItemAuthority(groupIndex, listIndex, 'priv_car_import')" :disabled="listItem.is_locked==1"></button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-config">
                                        <button class="checkbox-button" :class="{'is-check': listItem.cbox_permission.priv_config.enable == 1}" @click="changeAgentItemAuthority(groupIndex, listIndex, 'priv_config')" :disabled="listItem.is_locked==1"></button>
                                    </div>
                                    <div class="paca-table__body-col-list-item item-column column-extra"></div>
                                </div>
                            </div>
                        </div>
                        <div class="paca-table__empty" v-else>暫無資料</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as api from "@/script/apiService/api.js"
export default {
    name: "agent",
    data(){
        return{
            agentList: []
        }
    },
    methods: {
        itemCollapse(index){
            if(document.querySelector(`.list-${index}`).classList.contains("is-active")){
                document.querySelector(`.list-${index}`).classList.remove("is-active");
            }else{
                if(document.querySelector(".is-active")){
                    document.querySelector(".is-active").classList.remove("is-active");
                }
                document.querySelector(`.list-${index}`).classList.add("is-active");
            }
        },
        async getAgentList(){
            return await api.getAdminAgnetList();
        },
        async lockItem(listItem){
            let id = listItem.id;
            listItem.is_locked = (listItem.is_locked + 1) % 2;
            let locked = listItem.is_locked;
            if(locked == 0){
                let lockedResult = await api.putUserUnLock(id);
                if(lockedResult.error_status && lockedResult.error_status != "401"){
                    this.$message.error({
                        showClose: true,
                        duration: 2500,
                        message: "此鎖定無法更改!"
                    })
                }
            }else if(locked==1){
                let lockedResult = await api.putUserLock(id);
                if(lockedResult.error_status && lockedResult.error_status!="401"){
                    this.$message.error({
                        showClose: true,
                        duration: 2500,
                        message: "此鎖定無法更改!"
                    })
                }
            }
        },
        async changeAgentItemAuthority(groupIndex, listIndex, itemName){
            this.agentList[groupIndex].result[listIndex].cbox_permission[itemName].enable = (this.agentList[groupIndex].result[listIndex].cbox_permission[itemName].enable + 1) % 2;
            this.saveAgentAuthority(groupIndex, listIndex);
        },
        async saveAgentAuthority(groupIndex,listIndex){
            let privacyData = {
                "agent_permission": [
                    {"name": "priv_accounting", "enable": this.agentList[groupIndex].result[listIndex].cbox_permission.priv_accounting.enable},
                    {"name": "priv_car_edit", "enable": this.agentList[groupIndex].result[listIndex].cbox_permission.priv_car_edit.enable},
                    {"name": "priv_car_import", "enable": this.agentList[groupIndex].result[listIndex].cbox_permission.priv_car_import.enable},
                    {"name": "priv_config", "enable": this.agentList[groupIndex].result[listIndex].cbox_permission.priv_config.enable},
                    {"name": "priv_gate", "enable": this.agentList[groupIndex].result[listIndex].cbox_permission.priv_gate.enable}
                ]
            };
            let privacyResult = await api.putAgentPrivacy(this.agentList[groupIndex].result[listIndex].email,privacyData);
            if(!privacyResult.error_status){
                let res = await this.getAgentList();
                if(!res.error_status){
                    this.agentList = res;
                }
            } else if(privacyResult.error_status != '401' && privacyResult.error_status != '504'){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "發生錯誤"
                })
            }
        }
    },
    async activated(){
        let res = await this.getAgentList();
        if(!res.error_status){
            this.agentList = res;
        }
    }
}
</script>